const invertedMessages = {
  Username: 'external.idpSetUp.username',
  'Enter Username': 'external.idpSetUp.username.placeholder',
  'API Key': 'external.idpSetUp.apiKey',
  'Enter API Key': 'external.idpSetUp.apiKey.placeholder',
  Password: 'external.idpSetUp.password',
  'Enter Password': 'external.idpSetUp.password.placeholder',
  'Redirect URL': 'external.idpSetUp.redirectURL',
  'Enter Redirect URL (e.g., https://www.example.com)':
    'external.idpSetUp.redirectURL.placeholder',
  'ID proofing': 'external.idpSetUp.isProofing',
  'Invalid input': 'external.idpSetUp.invalidInput',
  'Please enter valid redirect URL.': 'external.idpSetUp.errorMsg',
  Environment: 'external.idpSetUp.environment',
  'Select Environment': 'external.idpSetUp.environment.placeholder',
  Back: 'external.idpSetUp.back',
  Save: 'external.idpSetUp.save',
  Saving: 'external.idpSetUp.saving',
  Production: 'external.idpSetup.environment.production',
  Preproduction: 'external.idpSetup.environment.preproduction',
};

export default invertedMessages;
